import angular from 'angular';

angular.module('company', []);
